import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Theme,
    withTheme, 
    WithTheme, 
    Typography,
    Grid,
    Button,
    Paper,
    List
} from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import { IReturn as Applicant } from '../../../api/resources/Applicant';
import { actions as identificationActions, IReturn as Identification } from '../../../api/resources/Identification';
import IdentificationItem from '../../../components/identification/Item';
import { ApplicationState } from '../../../reducers';
import EmptyState from '../../EmptyState';
import IdentificationAddModal from '../../identification/AddEditModal';

const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        itemPaper: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
        },
        metaData: {
            marginTop: 12,
        },  
        paperActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        paperTitle: {
            padding: theme.spacing(2),
            paddingBottom: 0,
        },
        spacer: {
            flex: 1,
        }
    });

interface IProps {
    identifications?: Identification[];
    applicant: Applicant;
};

interface IState {
    showAddModal: boolean;
}

const mapStateToProps = (state: ApplicationState, ownProps: IProps) => {
    const { applicant } = ownProps;
  
    return {
        identifications: applicant ? Object.values(state.identification.data).filter((item)=>item.applicant===applicant.id) : [],
    };
  };

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class ApplicantIDsCard extends React.PureComponent<FullProps, IState> {
    public state = {
        showAddModal: false,
    }

    public componentDidMount() {
        this.loadDependencies();
    }

    public componentDidUpdate(prevProps: FullProps) {
        const { applicant } = this.props;

        if (prevProps.applicant != applicant)
            this.loadDependencies();
    }

    public async loadDependencies() {
        const { applicant, dispatch } = this.props;

        if (applicant)
            dispatch(identificationActions.index(undefined, undefined, {applicant:applicant.id}));
    }
    
    render() {
        const { applicant, classes, identifications: ids } = this.props;
        const { showAddModal } = this.state;

        const identificationsMarkup = ids ? ids.map((identification, index) => (
            <IdentificationItem index={index} identification={identification} key={index} />
          )) : null;
              
        return (
            <Paper className={classes.itemPaper}>
                <Typography variant="subtitle1" className={classes.paperTitle}>
                    IDs
                </Typography>
                
                {identificationsMarkup && identificationsMarkup.length > 0 ? (
                    <List>{identificationsMarkup}</List>
                ) : (
                    <EmptyState icon='error' text='None to display' />
                )}

                <div className={classes.spacer}></div>
                <div className={classes.paperActions}>
                    <Button color="primary" onClick={this.onAdd}>Add</Button>
                </div>
                <IdentificationAddModal applicant={applicant} open={showAddModal} onDismiss={this.handleAddDismiss} />
            </Paper>
        )
    }

    private onAdd = () => {
        this.setState({showAddModal: true});
    }

    private handleAddDismiss = () => {
        this.setState({showAddModal: false});
    }
}

export default connect(mapStateToProps)(withTheme(withStyles(styles)(ApplicantIDsCard)));